export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popover.vue?vue&type=template&id=14c3c516&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/popover/popover.vue?vue&type=template&id=14c3c516&
// module id = 1186
// module chunks = 0